// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Rn7f","col":"styles_col__3kboF"};